var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcSmdPadGeneratorInteractionModel = require('../ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var SotflPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(SotflPadGeneratorInteractionModel, IpcSmdPadGeneratorInteractionModel);
SotflPadGeneratorInteractionModel.$class = 'SotflPadGeneratorInteractionModel';
module.exports = SotflPadGeneratorInteractionModel;

SotflPadGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('#Pins', '# Pins'), this.horizontalPadCount, [3, 4, 5, 6, 8])];
};

SotflPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintSotfl));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadPitchInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};